var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleGlassIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f_b-icon",
    "data-name": "f+b-icon",
    transform: "translate(-492 -524)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36048",
    "data-name": "Path 36048",
    d: "M520.74,1139h-9.48a1,1,0,0,0-1,1.08l1.5,18a1,1,0,0,0,1,.92h6.48a1,1,0,0,0,1-.92l1.5-18A1,1,0,0,0,520.74,1139Zm-9.48-2a3,3,0,0,0-2.989,3.25l1.5,18a3,3,0,0,0,2.989,2.75h6.48a3,3,0,0,0,2.989-2.75l1.5-18a3,3,0,0,0-2.989-3.25Z",
    transform: "translate(0 -601)",
    fill: "#141416",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36049",
    "data-name": "Path 36049",
    d: "M514,1151a1,1,0,1,0-1-1A1,1,0,0,0,514,1151Z",
    transform: "translate(0 -601)",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36050",
    "data-name": "Path 36050",
    d: "M518,1156a1,1,0,1,0-1-1A1,1,0,0,0,518,1156Z",
    transform: "translate(0 -601)",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36051",
    "data-name": "Path 36051",
    d: "M521.327,1144.99a15.167,15.167,0,0,1-4.994-.93l-.017-.01a17.16,17.16,0,0,0-5.809-1.05l.167,2.01a15.159,15.159,0,0,1,4.993.93l.017.01a17.04,17.04,0,0,0,5.477,1.04Z",
    transform: "translate(0 -601)",
    fill: "#141416"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Path_36390",
    "data-name": "Path 36390",
    width: 46,
    height: 46,
    rx: 23,
    transform: "translate(493 525)",
    fill: "none",
    stroke: "#fd4966",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleGlassIcon);
export default __webpack_public_path__ + "static/media/circleGlassIcon.0dc2b33b895602a8bcd9428fe1b6bb13.svg";
export { ForwardRef as ReactComponent };